export default "__VITE_ASSET__B7bl2osA__"